import { configureStore } from '@reduxjs/toolkit';
import cringeReducer from '../pages/cringe/cringeSlice';

export const store = configureStore({
  reducer: {
    cringe: cringeReducer
  }
});
